import {Routes} from '@angular/router';
import {AuthLayoutComponent} from '@app/shared/components/layouts/auth-layout/auth-layout.component';
import {MainLayoutComponent} from '@app/shared/components/layouts/main-layout/main-layout.component';
import {PreviewLayoutComponent} from '@app/shared/components/layouts/preview-layout/preview-layout.component';
import {authGuard} from '@core/guards/auth.guard';
import {analysisRefactorRoutes} from '@app/features/analysis-refactor/analysis-refactor.route';
import {previewRoute} from '@app/features/preview/preview.route';
import {landFormRoute} from '@app/features/land-form/land-form.route';
import {landRoute} from '@app/features/land/land.route';
import {authRoutes} from '@app/features/auth/auth.route';
import {analysisRoutes} from '@app/features/analysis/analysis.route';
import {gestGuard} from '@core/guards/gest.guard';
import {CONTACT_ROUTES} from '@app/features/request-demo/request-demo.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/hbu-Intelligence',
    pathMatch: 'full'
  },
  {
    path: 'hbu-Intelligence',
    canActivate: [gestGuard],
    loadComponent: () => import('./features/landing/landing-page.component')
  },
  {
    path: 'request-demo',
    canActivate: [gestGuard],
    children: [...CONTACT_ROUTES]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      ...authRoutes
    ]
  },

  {
    path: 'land-form',
    canActivate: [authGuard],
    children: [...landFormRoute]
  },
  {
    path: 'land',
    canActivate: [authGuard],
    children: [...landRoute]
  },
  {
    path: 'cost-revenue/:region_id/:land_id',
    canActivate: [authGuard],
    loadChildren: () => import('./features/scenario-details/scenario-details.routes')
      .then(m => m.scenarioDetailsRoutes)
  },
  {
    path: 'preview',
    canActivate: [authGuard],
    children: [...previewRoute]
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      // {
      //   path: 'analysis',
      //   children: [...analysisRoutes]
      // },
      {
        path: 'analysis',
        children: [...analysisRefactorRoutes]
      },
      {
        path: 'new-analysis',
        children: [...analysisRoutes]
      },
      {
        path: 'asset-price',
        loadComponent: () => import('./features/asset-prices/asset-prices.component'),
      },
      {
        path: 'home',
        loadComponent: () => import('./features/home/home.component'),
      },
      {
        path: 'assets-status',
        loadComponent: () => import('@app/features/assets-status/assets-status.component')
      },
      {
        path: 'analysis-base',
        loadComponent: () => import('@app/features/analysis-base/analysis-base.component')
      },
      {
        path: 'virtual-advisor',
        loadComponent: () => import('@app/features/virtual-advisor/virtual-advisor.component')
      },
      {
        path: 'repository',
        loadComponent: () => import('@app/features/repository/repository.component')
      },
      // {
      //   path: 'land-explorer',
      //   loadChildren: () => import('@app/features/land-explorer/land-explorer.routes')
      //     .then(m => m.LAND_EXPLORER_ROUTES)
      // },
      // {
      //   path: 'new-land-explorer',
      //   loadComponent: () =>
      //     import('@app/features/explore/components/new-land-explorer/new-land-explorer')
      //       .then(m => m.LandExplorerComponent)
      // }
    ]
  },

  {path: '**', redirectTo: 'home'}
];
